import { render } from "./AboutTemplate.vue?vue&type=template&id=5d0bc549"
import script from "./AboutTemplate.vue?vue&type=script&lang=js"
export * from "./AboutTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__